import React from 'react'
import IngredientGrid from '../Ingredients/IngredientGrid'
export default function Ingredients() {
    return(
    <IngredientGrid/>
    )
}
